import React from 'react';
import FilterBarFormControl, { FilterBarFormControlProps } from './FilterBarFormControl';
import { OutlinedTextFieldProps as TextFieldProps } from '@material-ui/core/TextField';
import Select from '../Inputs/Select';

export interface FilterBarSelectInputProps extends Omit<TextFieldProps, 'variant'> {
  formControlProps?: Omit<FilterBarFormControlProps, 'children'>;
}

const FilterBarSelectInput: React.FC<FilterBarSelectInputProps> = ({
  children,
  formControlProps,
  ...rest
}) => {
  return (
    <FilterBarFormControl {...formControlProps}>
      <Select size="small" {...rest}>
        {children}
      </Select>
    </FilterBarFormControl>
  );
};

export default FilterBarSelectInput;
